import { WIDGET_TYPE_AGENT_PLAN } from 'ee/work_items/constants';
import workItemAgentPlanQuery from './work_item_agent_plan.query.graphql';

export const buildAgentPlanWidget = (content) => ({
  type: WIDGET_TYPE_AGENT_PLAN,
  content,
  __typename: 'WorkItemWidgetAgentPlan',
});

export const writeAgentPlanToCache = ({
  cache,
  workItemId,
  workItemIid,
  content,
  useWorkItemFeatures,
}) => {
  const agentPlan = buildAgentPlanWidget(content);

  cache.writeQuery({
    query: workItemAgentPlanQuery,
    variables: { id: workItemId, useWorkItemFeatures },
    data: {
      workItem: {
        __typename: 'WorkItem',
        id: workItemId,
        iid: workItemIid,
        ...(useWorkItemFeatures
          ? { features: { __typename: 'WorkItemFeatures', agentPlan } }
          : { widgets: [agentPlan] }),
      },
    },
  });
};
